import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Stack,
} from "@mui/material";
import { QSO } from "@/types/qso.types";
import { Address } from "@/types/address.types";
import { formatDate, formatTime } from "@/utils/date.utils";

interface QSOTableProps {
  qsos: QSO[];
  loading?: boolean;
  onQRZClick?: (call: string) => void;
  addresses?: Address[];
  onAddAddress?: (call: string) => void;
}

export default function QSOTable({ qsos, loading, onQRZClick, addresses = [], onAddAddress }: QSOTableProps): JSX.Element {
  if (loading) {
    return <div>加载中...</div>;
  }

  const hasAddress = (call: string): boolean => {
    return addresses.some(addr => addr.call === call && addr.address.trim() !== '');
  };

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>呼号</TableCell>
            <TableCell>日期</TableCell>
            <TableCell>时间</TableCell>
            <TableCell>频率</TableCell>
            <TableCell>模式</TableCell>
            <TableCell>RST</TableCell>
            <TableCell>QSL 状态</TableCell>
            <TableCell>备注</TableCell>
            <TableCell>操作</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {qsos.map((qso) => (
            <TableRow key={qso.id}>
              <TableCell>{qso.call}</TableCell>
              <TableCell>{formatDate(qso.qso_date)}</TableCell>
              <TableCell>{formatTime(qso.time_on)}</TableCell>
              <TableCell>{qso.freq.toFixed(3)}</TableCell>
              <TableCell>{qso.mode}</TableCell>
              <TableCell>{formatRST(qso)}</TableCell>
              <TableCell>{qso.qsl_rcvd === "Y" ? "已收到" : "未收到"}</TableCell>
              <TableCell>{formatComment(qso)}</TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  {onQRZClick && (
                    <Button size="small" onClick={() => onQRZClick(qso.call)}>
                      查询 QRZ.com
                    </Button>
                  )}
                  {onAddAddress && !hasAddress(qso.call) && (
                    <Button size="small" variant="outlined" onClick={() => onAddAddress(qso.call)}>
                      添加地址
                    </Button>
                  )}
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function formatRST(qso: QSO): string {
  if (qso.mode === "FT8" || qso.mode === "FT4") {
    return `S:${qso.rst_sent} R:${qso.rst_rcvd}`;
  }
  return qso.rst_sent;
}

function formatComment(qso: QSO): string {
  const parts: string[] = [];
  if (qso.pota) {
    parts.push(`POTA\r\n${qso.pota}`);
  }
  if (qso.contest_id) {
    parts.push(qso.contest_id);
  }
  return parts.join("\r\n");
}
